var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.04 2.7002H13.32V3.59072C13.32 4.25348 12.7065 4.84756 11.88 4.84756C11.0534 4.84756 10.44 4.25348 10.44 3.59072V2.7002H4.69995V20.3002H19.04V2.7002ZM15.72 15.0074V15.0076H17.4199V15.0074H15.72ZM17.4199 4.16335V4.16316H14.8599C14.5599 5.39789 13.3399 6.31053 11.8799 6.31053C10.4199 6.31053 9.19994 5.39789 8.89994 4.16316H6.31994V13.8263H6.31995V4.16335H8.89995C9.19995 5.39809 10.42 6.31072 11.88 6.31072C13.34 6.31072 14.56 5.39809 14.86 4.16335H17.4199ZM8.01994 13.8265H8.01995V15.0076H6.31995L6.31994 18.8189V15.0074H8.01994V13.8265ZM15.42 15.3076H17.12V18.5191H6.61995V15.3076H8.31995V13.5265H6.61995V4.46335H8.67449C9.09789 5.72881 10.389 6.61072 11.88 6.61072C13.3709 6.61072 14.662 5.72881 15.0854 4.46335H17.12V13.5265H15.42V15.3076ZM10.1425 3.67563C10.1408 3.64752 10.14 3.61921 10.14 3.59072V3.0002H10.1399V3.59053C10.1399 3.61908 10.1408 3.64745 10.1425 3.67563ZM18.7399 3.0002V20H4.99995V20.0002H18.74V3.0002H18.7399ZM9.29994 15.0072V15.0074H11.2399V13.8264H11.2399V15.0072H9.29994ZM11.5399 13.5264H8.99994V15.3074H11.5399V13.5264ZM12.5199 15.0072V15.0074H14.4599V13.8264H14.4599V15.0072H12.5199ZM14.7599 13.5264H12.2199V15.3074H14.7599V13.5264Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketM);
export default __webpack_public_path__ + "static/media/ticket-m.ba182eab53d5472eeaa28c6ec9ead462.svg";
export { ForwardRef as ReactComponent };